import { c as _c } from "react/compiler-runtime";
import { ComponentProps } from 'react';
import { IntlBlock } from '@sola/ark-core/atoms/intl/Intl.tsx';
import { Alert, AlertProps } from '@sola/ark-core/molecules/alert/alert.tsx';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import i18n from '@sola/locales/index.ts';
import { LocalAlertConfig } from '../../types/localeAlerts.ts';
import { useLocalAlerts } from './local-alerts-provider.tsx';

/**
 * Single local alert.
 */
export const LocalAlert = t0 => {
  const $ = _c(31);
  const {
    alert,
    onClose,
    className,
    scrollIntoView: t1,
    scrollPosition: t2
  } = t0;
  const scrollIntoView = t1 === undefined ? true : t1;
  const scrollPosition = t2 === undefined ? "start" : t2;
  let alertProps;
  let id;
  let translationData;
  let translationKey;
  if ($[0] !== alert) {
    ({
      translationKey,
      translationData,
      id,
      ...alertProps
    } = alert);
    $[0] = alert;
    $[1] = alertProps;
    $[2] = id;
    $[3] = translationData;
    $[4] = translationKey;
  } else {
    alertProps = $[1];
    id = $[2];
    translationData = $[3];
    translationKey = $[4];
  }
  let t3;
  if ($[5] !== translationKey) {
    t3 = i18n.exists(`my:${translationKey}.title`);
    $[5] = translationKey;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const hasTitle = t3;
  let t4;
  if ($[7] !== translationKey) {
    t4 = i18n.exists(`my:${translationKey}.message`);
    $[7] = translationKey;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let hasMessage = t4;
  let t5;
  if ($[9] !== hasMessage || $[10] !== translationData || $[11] !== translationKey) {
    t5 = hasMessage ? <IntlBlock i18nKey={`my:${translationKey}.message`} values={translationData} /> : null;
    $[9] = hasMessage;
    $[10] = translationData;
    $[11] = translationKey;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let translation = t5;
  if (!hasMessage && !hasTitle && i18n.exists(`my:${translationKey}`)) {
    hasMessage = true;
    const t6 = `my:${translationKey}`;
    let t7;
    if ($[13] !== t6 || $[14] !== translationData) {
      t7 = <IntlBlock i18nKey={t6} values={translationData} />;
      $[13] = t6;
      $[14] = translationData;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    translation = t7;
  }
  let t6;
  if ($[16] !== hasTitle || $[17] !== translationData || $[18] !== translationKey) {
    t6 = hasTitle ? <IntlBlock i18nKey={`my:${translationKey}.title`} values={translationData} tOptions={{
      interpolation: {
        escapeValue: false
      }
    }} /> : null;
    $[16] = hasTitle;
    $[17] = translationData;
    $[18] = translationKey;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const title = t6;
  let t7;
  if ($[20] !== alertProps || $[21] !== className || $[22] !== hasMessage || $[23] !== hasTitle || $[24] !== id || $[25] !== onClose || $[26] !== scrollIntoView || $[27] !== scrollPosition || $[28] !== title || $[29] !== translation) {
    t7 = (hasMessage || hasTitle) && <Alert title={title} message={translation} scrollIntoView={scrollIntoView} scrollPosition={scrollPosition} closable={true} onClose={onClose ? () => onClose(id) : undefined} className={cn("scroll-mt-roomy-md", className)} {...alertProps} />;
    $[20] = alertProps;
    $[21] = className;
    $[22] = hasMessage;
    $[23] = hasTitle;
    $[24] = id;
    $[25] = onClose;
    $[26] = scrollIntoView;
    $[27] = scrollPosition;
    $[28] = title;
    $[29] = translation;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  return t7;
};

/**
 * Component that renders all local alerts.
 */
export const LocalAlerts: React.FC<Pick<ComponentProps<'div'>, 'className' | 'style'> & {
  scrollPosition?: AlertProps['scrollPosition'];
}> = t0 => {
  const $ = _c(11);
  const {
    className,
    style,
    scrollPosition
  } = t0;
  const {
    alerts,
    removeAlert
  } = useLocalAlerts();
  if (!alerts?.length) {
    return null;
  }
  let t1;
  if ($[0] !== alerts || $[1] !== removeAlert || $[2] !== scrollPosition) {
    let t2;
    if ($[4] !== removeAlert || $[5] !== scrollPosition) {
      t2 = alert => <LocalAlert alert={alert} onClose={removeAlert} key={alert.id} scrollPosition={scrollPosition} />;
      $[4] = removeAlert;
      $[5] = scrollPosition;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = alerts.map(t2);
    $[0] = alerts;
    $[1] = removeAlert;
    $[2] = scrollPosition;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== className || $[8] !== style || $[9] !== t1) {
    t2 = <div className={className} style={style}>{t1}</div>;
    $[7] = className;
    $[8] = style;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};